import { EntityUpgrades, EntityUpgradesList } from '../../types/game-types';
import { upgrades as clickUpgrades } from './GeneratorUpgrades/click';
import { upgrades as warriorUpgrades } from './GeneratorUpgrades/warrior';
import { upgrades as wizardUpgrades } from './GeneratorUpgrades/wizard';
import { upgrades as elfUpgrades } from './GeneratorUpgrades/elf';
import { upgrades as thiefUpgrades } from './GeneratorUpgrades/thief';
import { upgrades as bardUpgrades } from './GeneratorUpgrades/bard';
import { upgrades as clericUpgrades } from './GeneratorUpgrades/cleric';
import { upgrades as catapultUpgrades } from './GeneratorUpgrades/catapult';

export const upgrades: EntityUpgradesList = {
  // bird: [],
  click: clickUpgrades as EntityUpgrades,
  warrior: warriorUpgrades as EntityUpgrades,
  wizard: wizardUpgrades as EntityUpgrades,
  elf: elfUpgrades as EntityUpgrades,
  thief: thiefUpgrades as EntityUpgrades,
  bard: bardUpgrades as EntityUpgrades,
  cleric: clericUpgrades as EntityUpgrades,

  catapult: catapultUpgrades as EntityUpgrades,
};
